import styled from 'styled-components'
import { ButtonText } from 'src/comps/Button/styles'
import { colors, updatedMedia } from 'client/styles'

export const PaxSelectorBase = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;

  & > div:first-child {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  ${updatedMedia.desktop} {
    display: block;
    height: auto;
    max-height: none;
    border: 2px solid ${colors.grey1};
    border-radius: 8px;
    z-index: 20;

    & > div:first-child {
      flex: auto;
      overflow-y: inherit;
    }
  }
`

export const AddRoom = styled.div`
  flex: 0 0 auto;
  padding-block: 20px;
  padding-inline: 20px;
  border-block-start: 1px solid ${colors.grey4};
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  justify-content: space-between;
  margin-block-start: auto;

  button {
    width: auto;
  }
`

export const AgeRange = styled.span`
  display: block;
  font-size: 12px;
  line-height: 1.4;
  color: ${colors.grey2};
`

export const ListItems = styled.li`
  padding-block: 1rem;
  padding-inline: 1rem;
  border-block-end: 1px solid ${colors.grey4};
  display: flex;
  flex-direction: column;
`

export const TitleRoom = styled.span`
  color: ${colors.dark};
  font-weight: 700;
`

export const ItemSelector = styled.li`
  margin-block-start: 20px;
`

export const ListChildrenAges = styled.ul`
  padding-inline-start: 10px;

  li {
    margin-block-start: 10px;
  }
`

export const RemoveRoom = styled(ButtonText)`
  display: inline-block;
  margin-block-start: 15px;
  padding-block: 15px;
  padding-inline: 15px;
  align-self: flex-end;
  text-align: end;
  font-weight: 700;
`

export const TitleAges = styled.span`
  display: block;
  margin-block: 1rem;
  margin-inline: 0;
`

export const Inputs = styled.div`
  display: flex;
  flex-wrap: wrap;
`
